export const config = {
  minChar: 3,
  maxChar: 30,
  fetchPeriods: 1000,
  unitZoomLevel: 7,
  queryCharsToRemove: /[;,/?:@&=+$-_.!~*'()#]*/g
};
